import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <div className="grid place-items-center min-h-[60vh] px-6 text-center">
      <div>
        <p className="text-eol-pink text-7xl font-extrabold">404</p>
        <h1 className="mt-3 text-2xl font-bold text-eol-white">Страница не найдена</h1>
        <Button asChild className="mt-6">
          <Link to="/">На главную</Link>
        </Button>
      </div>
    </div>
  );
}
